import type { Feature } from '@luna/gatekeeper';

export const contactlessPayments: Feature = {
    enabled: false,
    _description:
        'Displays contactless payments card in the bank card settings page and credit card functions page',
};
